import React, { useState } from 'react'
import { Input, Select } from 'antd'

interface IProps {
  type: string
  defaultValue: any
  setCorrection: (value: string) => void
}

const FieldMulti = (props: IProps) => {
  const { type, defaultValue, setCorrection } = props
  const parsed =
    typeof defaultValue === 'string' ? JSON.parse(defaultValue) : defaultValue
  const [values, setValues] = useState(parsed)
  const prefixOptions = [
    { label: 'Mr.', value: 'Mr.' },
    { label: 'Mme', value: 'Mme' },
  ]

  const handleChange = (fieldName: string, value: string) => {
    const newValues = { ...values }
    newValues[fieldName] = value
    setValues(newValues)
    setCorrection(newValues)
  }

  const fullnameFields = () => {
    return (
      <>
        <Select
          defaultValue={values.prefix}
          style={{ width: 150 }}
          onChange={(value: string) => {
            handleChange('prefix', value)
          }}
          options={prefixOptions}
        />
        <Input
          defaultValue={values.first}
          placeholder="Prénom"
          style={{ width: 200 }}
          onChange={e => {
            handleChange('first', e.target.value)
          }}
        />
        <Input
          defaultValue={values.last}
          placeholder="Nom"
          style={{ width: 200 }}
          onChange={e => {
            handleChange('last', e.target.value)
          }}
        />
      </>
    )
  }

  const phoneFields = () => {
    return (
      <>
        <Input
          defaultValue={values.area}
          placeholder="+33"
          style={{ width: 100 }}
          onChange={e => {
            handleChange('area', e.target.value)
          }}
        />
        <Input
          defaultValue={values.phone}
          placeholder="Numéro"
          style={{ width: 300 }}
          onChange={e => {
            handleChange('phone', e.target.value)
          }}
        />
      </>
    )
  }

  const addressFields = () => {
    return (
      <>
        <Input
          defaultValue={values?.addrLine1 || values?.addr_line1}
          placeholder="Adresse ligne 1"
          style={{ width: 300 }}
          onChange={e => handleChange('addrLine1', e.target.value)}
        />
        <Input
          defaultValue={values?.addrLine2 || values?.addr_line2}
          placeholder="Adresse ligne 2 (optionnel)"
          style={{ width: 300 }}
          onChange={e => handleChange('addrLine2', e.target.value)}
        />
        <Input
          defaultValue={values?.postal}
          placeholder="Code postal"
          style={{ width: 200 }}
          onChange={e => handleChange('postal', e.target.value)}
        />
        <Input
          defaultValue={values?.city}
          placeholder="Ville"
          style={{ width: 200 }}
          onChange={e => handleChange('city', e.target.value)}
        />
        <Input
          defaultValue={values?.country}
          placeholder="Pays"
          style={{ width: 200 }}
          onChange={e => handleChange('country', e.target.value)}
        />
      </>
    )
  }

  const fields = () => {
    switch (type) {
      case 'fullname':
        return fullnameFields()
      case 'phone':
        return phoneFields()
      default:
        return addressFields()
    }
  }

  return fields()
}

export default FieldMulti
